export const CAPTCHA_NAME: string = 'captcha';

export const CAPTCHA_TIMEOUT: number = 1000 * 60 * 8; // 8 minutes
